import styled from 'styled-components';
import { media } from 'designsystem/index';

const ButtonsSection = styled.div`
  display: inline-flex;
  position: relative;
  align-items: right;
  top: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
  
  ${media.desktop`
    position: fixed;
    top:0;
    bottom:initial;
    width: auto;
  `}
`;

export default ButtonsSection;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/Buttons/ButtonsSection.jsx